/**
 * Client-side preflight for the Schwab Advisor Center "RMD All Ages" export.
 *
 * The file is a CSV with a three-line, non-CSV preamble:
 *
 *   301 Records exported
 *   RMD All Ages for FIRM Account CLARO ADVISORS LLC as of 09/18/2026 09:19 PM ET
 *   RMD Filtered by (AccountType = 'All Account Types')
 *
 *   Account,First Name,Last Name,...
 *
 * Only the first line is checked, the same check the upload endpoint does; pm-cli parses the file fully at
 * load time. The "as of" timestamp is read for display only.
 */

const RECORD_COUNT_PATTERN = /^\s*(\d+)\s+Records?\s+exported\s*$/i;
const AS_OF_PATTERN = /\bas of\s+(\d{2}\/\d{2}\/\d{4}\s+\d{1,2}:\d{2}\s*(?:AM|PM)\s*ET)\b/i;

export interface SchwabRmdExportPreflight {
    /** declared in the first line; NaN when the first line is not "<n> Records exported" */
    recordCount: number;
    /** "MM/DD/YYYY HH:MM AM ET" as printed in the preamble, if present */
    asOfLabel?: string;
    problems: string[];
}

export const preflightSchwabRmdExport = (text: string): SchwabRmdExportPreflight => {
    const lines = text
        .replace(/^\uFEFF/, '')
        .replace(/\r\n?/g, '\n')
        .split('\n');
    const countMatch = lines[0]?.match(RECORD_COUNT_PATTERN);
    const asOfMatch = lines
        .slice(0, 3)
        .map((line) => line.match(AS_OF_PATTERN))
        .find(Boolean);

    return {
        recordCount: countMatch ? Number(countMatch[1]) : NaN,
        asOfLabel: asOfMatch ? asOfMatch[1].replace(/\s+/g, ' ').toUpperCase() : undefined,
        problems: countMatch
            ? []
            : ['The first line should read "<n> Records exported". Is this the Schwab RMD All Ages export?'],
    };
};
